import { ControllerContext } from '@shared/context/ControllerContext';
import { accessRequestFlowShortcodeSelector } from '@shared/reducers/prayerhub';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Flow } from '../../Flow';
import { PrayerHubContext } from '../context/PrayerHubContext';

export const RequestAccessFlow = (props) => {
  const history = useHistory();
  const { currentPrayerHubId, currentPrayerWallId } = useContext(PrayerHubContext);
  const shortcode = useSelector(accessRequestFlowShortcodeSelector(currentPrayerHubId, currentPrayerWallId));

  if (shortcode === undefined) {
    return null;
  }

  const context = {
    goToPrayerHub: () => history.replace('/'),
    goToPrayerFlow: () => history.replace('/share'),
  };

  return (
    <Controller>
      <Flow shortcode={shortcode} context={context} />
    </Controller>
  );
};

const Controller = (props) => {
  const history = useHistory();
  const parent = useContext(ControllerContext);
  const context = {
    ...parent,
    goBack: () => history.goBack(),
  };
  return <ControllerContext.Provider value={context}>{props.children}</ControllerContext.Provider>;
};
